import { render } from "./add-admin.vue?vue&type=template&id=2c2f2f5e"
import script from "./add-admin.vue?vue&type=script&lang=js"
export * from "./add-admin.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/stages_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__